export const ctaData = {
  title: 'CopadoCon 2025',
  subtitle: 'In Colaboration with Bengaluru Dreamin | September 13',
  description: '',
  date: 'SEPTEMBER 13, 2025',
  location: 'Dreamforce',
  duration: '',
  registerText: 'Register Now',
  registerLink: 'https://konfhub.com/checkout/copaodcon-2025'

};
